window.addEventListener('DOMContentLoaded', function () {
    var isTypeurl = window.location.href;//判断是否是详情页

    setTimeout(Txtinput, 3000);
    setTimeout(hideBlank, 2000);
    setTimeout(Addinfo, 1000);
    setTimeout(eq_page, 3000);


    var makeupTheDifferenceQty = '';
    if (getUrlParam('_qty') != null) {
        makeupTheDifferenceQty = getUrlParam('_qty');
    } else {
        makeupTheDifferenceQty = getUrlParam('_amount');
    }
    if (makeupTheDifferenceQty != null) {
        $("#quantity").val(makeupTheDifferenceQty);
    }

      if(getUrlParam('_salesmanager') != null){
        $("#sales-manager").removeAttr("disabled");   
        $("#sales-manager").val(getUrlParam('_salesmanager'));
    }


    if (navigator.userAgent.match(/mobile/i)) {
        var headerHeight = $("#header").height();
        $('.add_to_cart').click(function () {
            var menHeight = ($("#variant_select_1").offset().top - headerHeight - 70);
            var men = $('#variant_select_1').val();
            if (men == null) {
                $('html,body').animate({ scrollTop: menHeight }, 100);
            }
        })
    }
    $('#mask-mi').click(function () {
        $(this).css('display', 'none');
        $('#mi-popup-kk').css('display', 'none');
        document.getElementById("buttom-x").style.display = 'none';//wwh8.4新增
        $(".touchevents").css('overflow', '')//wwh8.5新增
    });

    $('.size-cm').click(function () {
        $(this).addClass('size_checked')
        $('#inTable').addClass('size_hidden');;
        $('#cmTable').removeClass('size_hidden');
        $('.size-in').removeClass('size_checked')
    })

    $('.size-in').click(function () {
        $(this).addClass('size_checked');
        $('#cmTable').addClass('size_hidden');
        $('#inTable').removeClass('size_hidden');
        $('.size-cm').removeClass('size_checked')
    })


    //     pc端
    $('.homepage-slideshow.mobile_hide ').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });
    //     移动端
    $('.homepage-slideshow.pc_hide').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    //wwh8.4新增
    $('.mi-close-custom').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
        document.getElementById("buttom-x").style.display = 'none';
        $(".touchevents").css('overflow', '')
    });

    $('.header__search span').eq('1').click(function () {
        $('.search_field').css('display', 'flex').animate({ top: "30px" }, 50)
        //wwh修改search5.12
        $('.search_field_custom').css('display', 'inline').animate({ top: "30px" }, 50)
        $('#mask-search').css('display', 'block')
        $('html').css('overflow', 'hidden');

    })
    //wwh修改(手机端search点击关闭隐藏)
    /*--------------------------*/
    $('.search_container_svg_custom_mobile').click(function () {
        $('.dropdown_container_custom_mobile').hide()
        $('html').css('overflow', 'auto');
        $("body").removeClass("is-active")
    })
    $('.icon-search-mobile-click-scroll-custom').click(function () {
        if ($(window).width() < 798) {
            $('html').css('overflow-y', 'hidden');
        }
    })
    /*--------------------------*/
    $('#mask-search , .search-modal__close-button').click(function () {
        $('.search_field').removeAttr('style')
        $('#mask-search').removeAttr('style')
        $('html').css('overflow', 'auto');
    })

    var interval1 = setInterval(() => {
        var Material = $('input[value="Blank(No Name/Number)"]');
        var properties = $('input[name="properties[Material*]"]').parent();
        var bcpo = $('#bcpo');
        var text = bcpo.find('input[type="text"]').parent();
        var file = $("input[name='properties[Upload Logo]'],input[name='properties[Team Logo]'],input[name='properties[Back Logo]']");
        var button = $("input[name='properties[A/C Patch on Left Chest (Optional)]'],input[name='properties[Logo Location(Optional)]'],input[name='properties[Logo Location(Optional)][]']");
        var Logo_Location = $.trim($('input[name="properties[Logo Location(Optional)][]"]:checked , input[name="properties[Logo Location(Optional)]"]:checked').val());
        var Upload_Logo = $('input[name="properties[Upload Logo]"]').parents('.bcpo-file');
        var style = $("input[name='properties[Style]']");
        var inside_lining = $("input[name='properties[Inside Lining]']");
        var sleeves =  $("input[name='properties[Sleeves]']");
        var design  =$('.single-option-selector.bcpo-auto-images').find('input');
        var Back_Logo =  $('input[name="properties[Back Logo]"]')
        var Back_Number =  $('input[name="properties[Back - Number]"]')
        if (bcpo.length > 0) {
            // 关于漏单
            setTimeout(remove_add_cart, 3000)
            if (isTypeurl.indexOf('products') != -1) {
                var goods_name = ($('h1.product_name').text()).toLowerCase();
                add_button(goods_name);
                setTimeout(AddSize(goods_name), 1000);
                setTimeout(productCus(goods_name), 1000);
            }

            properties.find('label').click(function () {
                if ($(this).siblings('input').val().indexOf('Blank') < 0) {
                    bcpo.find('input[type="text"]').attr("disabled", false);
                    file.attr("disabled", false);
                    button.attr("disabled", false);
                } else {
                    bcpo.find('input[type="text"]').attr("disabled", true);
                    file.attr("disabled", true);
                    button.attr("disabled", true);
                }
            })

            button.next('label').click(function () {
                if ($(this).prev('input').attr("disabled") == "disabled") {
                    var html = '<div class="tip-top"> Please select right Material !</div>';
                    $(this).find('.tip-top').remove();
                    text.find('.tip-top').remove();
                    $(this).append(html);
                    setTimeout(removeTip, 3000);
                }
                if ($(this).text().indexOf("None") == -1 && Material.is(":checked") == false) {
                  console.log('11111')
                    Material.parent('.bcpo-button-parent').css('display', 'none');
                } else {
                    Material.parent('.bcpo-button-parent').css('display', 'inline-block');
                }

                if ($(this).prev('input').attr('name') == 'properties[Logo Location(Optional)][]' || $(this).prev('input').attr('name') == 'properties[Logo Location(Optional)]') {
                    // hide_Upload($(this),Upload_Logo)
                }

            })

            $('.bcpo-front-button-label').click(function () {
                    if ($('.bubble.tip-top').length > 0) {
                      $('.bubble.tip-top').addClass('active');
                    }
            })


            text.click(function () {
                if ($(this).find('input').attr("disabled") == "disabled") {
                    var html = '<div class="tip-top"> Please select right Material !</div>';
                    $(this).find('.tip-top').remove();
                    text.find('.tip-top').remove();
                    $(this).append(html);
                    setTimeout(removeTip, 3000);
                }
            })

            if (Material.is(":checked")) {
                Material.removeAttr('checked')
                properties.find('input').eq(0).trigger("click");
            }
            if (Material.length < 1 && (goods_name.indexOf('pants') > -1 || goods_name.indexOf('hat') > -1)) {
                $('#add_to_cart').prop('disabled', 'disabled')
            }

            // Choose Neckline
            var Shape = $('input[name="properties[Choose Neckline]"]').parents('.bcpo-buttons');
            Shape.find('.bcpo-button-parent').each(function () {
                var Shape_val = $(this).find('input').val();
                var Shape_img = '';
                var Shape_title = ''
                if (Shape_val.indexOf('V Shape') != -1) {
                    Shape_img = 'https://bigtur.360yituo.com/turntable/img/V_Shape.jpg'
                    Shape_title = 'V Shape'
                } else if (Shape_val.indexOf('Round Shape') != -1) {
                    Shape_img = 'https://bigtur.360yituo.com/turntable/img/Round_Shape.jpg'
                    Shape_title = ' Round Shape'
                }
                $(this).find('.bcpo-front-button-label').html('<img src="' + Shape_img + '"><p>' + Shape_title + '</p>').addClass('label_img');
            })

            // 球衣 去掉 shorts 选项
            if (style.length > 0) {
              hide_Shorts('Top');
                style.next('label').click(function () {
                    selectedValue = $(this).parent().find('input').val();
                    hide_Shorts(selectedValue);

                })
            }

            //  隐藏 Upload Logo
            if (Logo_Location == 'None') {
                Upload_Logo.hide();
            }

          // inside_lining

          if(inside_lining.length>0){
            inside_lining.next('label').on({
            mouseover: function () {
              var html = '';
             if($(this).siblings('input').val() == 'Lightweight'){
               html = "<div class='Lightweight_title tip-top Lightweight'>Lightweight satin lining has polyester fiber fill material.<br> Thinner jacket, ideal for warmer climate.</div>"
             }else{
               html = "<div class='Lightweight_title tip-top Quilted'>Quilted satin lining has poly cotton  fiber fill material.<br>Thicker jacket, idea for colder climate. </div>"
             }
              if($(window).width() < 764){
                $(this).parents('.single-option-selector').append(html);
                $('.Lightweight_title').slideDown();    
              }else{
                    $(this).stop(true, true).after(html);
              }
          
            },
            mouseout: function () {      
           if($(window).width() < 764){
                $(this).parents('.bcpo-button-parent').siblings('.Lightweight_title').stop(true, true).remove();
                
              }else{
                $(this).siblings('.Lightweight_title').stop(true, true).remove();
              }
            }
              
            });
            
          }
                $('.question_file').on({
                    mouseover: function () { 
                      if (!$(this).parents('.selector-wrapper').find('.wen-div-css-mobile').hasClass('wen-div-css-pc')) {
                          $(this).parents('.selector-wrapper').find('.wen-div-css-mobile').stop(true, true).slideToggle()
                        }
                    },
                    mouseout: function () { 
                      if (!$(this).parents('.selector-wrapper').find('.wen-div-css-mobile').hasClass('wen-div-css-pc')) {
                           $(this).parents('.selector-wrapper').find('.wen-div-css-mobile').stop(true, true).slideToggle()
                      }  
                    }
                });

           $('.question_buttons').click(function () {
              $(this).parents('.bcpo-default').find('.bubble.tip-top').stop(true, true).slideDown();   
              $('.bubble.tip-top').hasClass('active') ? $('.bubble.tip-top').removeClass('active') : '';
           })
          
          $(document).on('click', function(event) {
            var target = $(event.target);
            if (!target.closest('.question_buttons').length) {
              $('.bubble.tip-top').slideUp();
            }
          });

          var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if (mutation.type === 'childList') {
                  var bcpoValue = $(mutation.target).closest('.selector-wrapper').find('.bcpo-value');
                  if (bcpoValue.text().includes('Leather') && !bcpoValue.text().includes('Leather (Faux Leather)')) {
                      bcpoValue.contents().filter(function() {
                          return this.nodeType === 3 && this.nodeValue.includes("Leather");
                      }).each(function() {
                          this.nodeValue = this.nodeValue.replace("Leather", "Leather (Faux Leather)");
                      });
                  }
              }
          });
      });

      sleeves.click(function () {
          var bcpoValue = $(this).parents('.selector-wrapper').find('.bcpo-value');
          observer.observe(bcpoValue[0], { childList: true, subtree: true });
      });

          if(design.length >0){
              if(design.not(':checked')){
              var isDesign1 = design.not(':checked').val().replace(/\(.*?\)/, '') === 'Design 1';
            if(isDesign1){
                Back_Number.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
            }else{
               Back_Logo.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
            }    
          }
          design.on('click', function() {
          var val_variants = $(this).val(); 
          var isDesign1 = val_variants.replace(/\(.*?\)/, '') === 'Design 1';  // 判断是否是Design 1

          // 根据isDesign1来控制Back Logo的显示和禁用
          if (isDesign1) {
              Back_Logo.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
          } else {
              Back_Logo.prop('disabled', false).parents('.selector-wrapper').removeAttr('style')
          }
      
          // 根据isDesign1来控制Back Number的显示和禁用
          if (isDesign1) {
              Back_Number.prop('disabled', false).parents('.selector-wrapper').removeAttr('style')
          } else {
              Back_Number.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
          }
      });
          }






          
            clearInterval(interval1);
        }
    }, 1000);



    if (isTypeurl.indexOf('customer-feedback') != -1) {
        var interval2 = setInterval(() => {
            var radio_question = $('.radio-question');
            if (radio_question.length > 0) {
                $('.radio-question , .label-question').click(function () {
                    $(this).parents('.div-radio-question').siblings().find('input').removeAttr("checked");
                    $(this).parents('.div-radio-question').children('input').attr('checked', 'checked');
                })
                $('.radio-question , .label-question').mouseover(function () {
                    var s = event.fromElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '#eaf0fe')
                    }
                })
                $('.radio-question , .label-question').mouseout(function () {
                    var s = event.toElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '')
                    }
                })
                $('.div-radio-question').click(function () {
                    $(this).siblings().find('input').removeAttr("checked");
                    $(this).children('input').attr('checked', 'checked');
                })
                $('.div-radio-question').mouseover(function () {
                    var s = event.fromElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '#eaf0fe')
                    }

                })
                $('.div-radio-question').mouseout(function () {
                    var s = event.toElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '')
                    }

                })

                $('.label-question input').bind('input propertychange', function () {
                    var input_width = $(this).width();
                    var current_width = parseInt($(this).val().length) * 12;
                    if (input_width < current_width) {
                        if (current_width < 816) {
                            $(this).css('width', current_width)
                        } else {
                            $(this).css('width', '816px')
                        }
                    }
                })

                clearInterval(interval2);
            }
        }, 1000)
    }




    $('#mi-close').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
    })

    $('.sc-jNHqnW.iYzQjy.pf-cmIpgn').click(function () {
        eq_page()
    })

    // 2022 1107 
    // 客服 pc端
    $('.gatsby-image-wrapper').click(function () {


        if ($(window).width() < 764) {
            if ($('#mask-mobile').css('display') == 'none') {
                $('#mask-mobile').css('display', 'flex')
            } else {
                $('#mask-mobile').hide()
            }
        } else {
            if ($('#mask-phone').css('display') == 'none') {
                $('#mask-phone').show()
            } else {
                $('#mask-phone').hide()
            }
        }
    })


    //  cart 页面 提示框
    $(".js-deleteitem-ajax").on("click", function () {

    });
    $(".cart_dialog .btnnoOk ,.modal-backdrop").on("click", function () {
        $(".cart_dialog").css("display", "none");
        $('.modal-backdrop.fade').css('display', 'none').removeClass('show')
    });

    $("#delallpartdialog").on("click", ".btnok", function () {
        var index = $(this).attr('data-index');
        window.location.href = "/cart/change?line=" + index + "&amp;quantity=0"
        $(this).parents(".cart_dialog").css("display", "none");
        $('.modal-backdrop.fade').css('display', 'none').removeClass('show')
    });

    // 首页提示词隐藏
    if ($(window).width() <= 780) {
        $(window).scroll(function () {
            var top = $(document).scrollTop();
            if (top > 100) {
                $('.promo_banner').hide()

            } else {
                $('.promo_banner').show()
            }
        })

    }

    // 详情页滑动
    if (isTypeurl.indexOf('products') != -1) {
        if ($(window).width() > 780) {
            var interval3 = setInterval(() => {
                if ($('#bcpo').length > 0) {
                    var box_height = $('#purchase-details__buttons').offset().top;
                    var left_height = $('.nine.columns.alpha').height();
                    var box_top = $('.container.main.content').offset().top;
                    var scrollBottom = box_height + box_top;
                    var fheight = box_height - left_height;//左边剩下空的高度
                  if(fheight >100){
                    $(window).scroll(function () {
                        var scrollTop = $(window).scrollTop();
                        if (scrollTop >= box_top + 10 && scrollTop <= scrollBottom) {
                            $('.nine.columns.alpha').addClass('columns_active');
                            if (scrollTop >= fheight + box_top - 50) {
                                $('.gallery-wrap.js-product-page-gallery.clearfix.gallery-arrows--true.bottom-thumbnails.slideshow_animation--slide').css('top', (fheight - 97) + 'px').addClass('wrap_fix_bottom').removeClass('wrap_fix')
                            } else {
                                var wrapfixtop = '10px'
                                $('.gallery-wrap.js-product-page-gallery.clearfix.gallery-arrows--true.bottom-thumbnails.slideshow_animation--slide').addClass('wrap_fix').removeClass('wrap_fix_bottom').css('top', wrapfixtop)
                            }
                        } else {
                            $('.nine.columns.alpha').removeClass('columns_active');
                            $('.gallery-wrap.js-product-page-gallery.clearfix.gallery-arrows--true.bottom-thumbnails.slideshow_animation--slide').removeClass('wrap_fix')//当移到顶部时去掉
                        }
                    });
                    clearInterval(interval3);
                }
                }
            }, 1000);

        }
    }
    $('body').on("click", 'li .featured-links', function (e) {
        $('a.icon-cart.mini_cart.dropdown_link').trigger("click");
    });



})
function resetPassword(index) {
    var div = $("#delallpartdialog");
    div.find('.btnok').attr('data-index', index);
    div.css("display", "block");
    $('.modal-backdrop.fade').css('display', 'block').addClass('show')
}

function remove_add_cart() {
    $('#add_to_cart').removeAttr('style');
    $('#add_to_cart').parents('.purchase-details__buttons').removeAttr('style');
}

function hide_Shorts(selectedValue) {
    var Shorts = $("input[name='properties[Logo Location(Optional)][]'][value='Shorts']");
    if (selectedValue == 'Top') {
        $('input[name="properties[Front - Number(Shorts Number)]"]').parents('.bcpo-text').find('.bcpo-label .bcpo-title').text('Front - Number:')
        Shorts.parent().hide()
        Shorts.prop("checked", false);
    } else {
       $('input[name="properties[Front - Number(Shorts Number)]"]').parents('.bcpo-text').find('.bcpo-label .bcpo-title').text('Front - Number(Shorts Number):')
        Shorts.parent().show()
    }
}

function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]); return null; //返回参数值
}

function removeTip() {
    $('.tip-top').remove();
}

function AddSize(goods_name) {
    var obj = $("div[class='selector-wrapper bcpo-simple bcpo-default']");
    var modal = '<a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 10px;display:inline-block;"><span class="icon-f-09"></span> Size guide</a>';
    if (typeof (obj.html()) == "undefined" || obj == null) {
        setTimeout(AddSize, 1000);
    }
    else {
        obj.each(function () {
            $(this).find(".bcpo-label label").append(modal);
        });
      var html = '';
          if(goods_name.indexOf('soccer') > -1){
            html = '<p class="Size_Title Title_Men">Our soccer jerseys are slim fit;For a standard fit, go one size up;For casual wear, two sizes up is recommended for extra comfort.</p>'  
          }else if(goods_name.indexOf('softball') > -1){
            html = '<p class="Size_Title Title_Women">Our softball jerseys are Standard fit;For casual wear, one sizes up is recommended for extra comfort.</p>'   
          }else if(goods_name.indexOf('baseball') > -1){
            html = '<p class="Size_Title Title_Women">Our baseball jerseys are Standard fit;For casual wear, one sizes up is recommended for extra comfort.</p>'
          }
      if(html.length>1){
          $('#modalProductInfo .modal-body p.fi-text-align.fi-text-align-width').eq(0).before(html) 
          text = $('.uk-sex-fi .bcpo-front-button-label-custom.active').text()

        text = text.substring(0, text.length - 2);
        if($('.Title_'+text).length>0){
          $('.Title_'+text).show()
        }
  
      }
    }
}


function productCus(goods_name) {
      var _upload = $("#bcpo input[type='file']");
    if (_upload.attr("data-price") != null) {
        _upload.attr("accept", "image/png, image/jpeg,image/jpg");
        if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
            $("span[class='bcpo-title']").each(function () {
                var htm = $(this).html();
                var title = $(this).text();
                if (title == "Material*:") {
                    $(this).next().children().css("margin-left", "15px");
                }
                if (htm.indexOf('*') > -1) {
                    if(goods_name.indexOf('baseball') > -1 && htm.indexOf('Women\'s') > -1){
                    htm = htm.replace("*", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span> <span class='question_file'></span>");
                    htm1 = "<div class='wen-div-css-mobile wen-div-css-pc' style='width: 60%;display: block;'><span style='color:#524e4e;line-height: 20px;word-spacing: -1px;display: inline-block;'>Our women’s baseball jerseys have a slim fit. For a standard fit, size up;<br> for extra comfort, choose a looser size.</span></div>"
                    $(this).html(htm);
                    $(this).parent().after(htm1)
                      $(this).parents('label').css('padding-bottom','0px')
              }else{
                    htm = htm.replace("*", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span>");
                    $(this).html(htm);      
              }             
                }

              if(title.indexOf('Team Name Font Style') != -1){
                 htm = htm.replace(":", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span>:");
                  $(this).html(htm);  
              }

                if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
                    // htm = "<font size=\"-2\">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>";
                    // $(this).append(htm);
                }

                if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1 || htm.indexOf('Upload Logo') > -1) {
                    htm = htm.replace(":", "<span class='question_file'></span>: <div class='wen-div-css-mobile' ><span style='color:#524e4e;'>Don't upload copyrighted logos.</span></div>");
                    $(this).html(htm);
                }

                if (htm.indexOf('Logo Location(Optional)') > -1) {
                    htm = htm.replace(":", "<span class='question_file'></span>:");
                    htm1 = "<div class='wen-div-css-mobile' style='width: 83%;'><span style='color:#524e4e;'>If the option isn't available below, please leave a note in the order specifying the required location.</span></div>"
                    $(this).html(htm);
                    $(this).parent().after(htm1)
                }
                if (htm.indexOf('Choose Neckline') > -1) {
                    htm = ("<span>*</span>");
                    $(this).append(htm);
                }


            });
        }
        _upload.attr("onchange", "showFileName($(this))");
    }
    else {
        setTimeout(productCus, 3000);
    }
}


function Txtinput() {
    if ($("input[name='properties[Back Number]']").attr("data-price") != null) {
        //         不允许输入“|”
        $("input[type='text']").keyup(function () {
            if ($(this).val().indexOf("|") != -1) {
                $(this).val("");
            }
        });
        // 判断是ios还是安卓
        if (ios_or_android() == 'ios') {
            $("input[type='text']").on("keyup", function () {
                var param = $(this).val();
                $(this).val(param.replace(regRule, ""));
            })
        } else {
            $("input[type='text']").on("input", function () {
                var param = $(this).val();
                $(this).val(param.replace(regRule, ""));
            })
        }
    } else {
        setTimeout(Txtinput, 3000);
    }
}



/*
@功能：判断终端是ios还是安卓
 */
function ios_or_android() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
        return 'and';
    } else {
        return 'ios';
    }
}


function Addinfo() {
     var good_name = $('h1.product_name').text();
    if((good_name.indexOf('Baseball') != -1 || good_name.indexOf('Basketball') != -1 || good_name.indexOf('Hockey') != -1 || good_name.indexOf('Hoodie') != -1 || good_name.indexOf('Football') != -1) && (good_name.indexOf('Shorts') == -1 && good_name.indexOf('Shirt') == -1) && good_name.indexOf('Custom Cream Black Hockey Jersey') == -1&& good_name.indexOf('Custom Black White Pinstripe Black-White Authentic Baseball Good Game Family Community Jersey') == -1){
    var mi = $('input[type=radio][name="properties[Material*]"]').parent().parent().prev();
    var obj = $("div[class='selector-wrapper bcpo-simple bcpo-buttons']");
    if (typeof (obj.html()) == "undefined" || obj == null) {
        setTimeout(Addinfo, 1000);
    } else {
        var html = "<div class='scmi_div'><a href='javascript:void(0);' class='scmi'  onclick='ClickMi()'>Comparing Methods<a/></div>";
        mi.parent().append(html);
    }
    }

}



// check if input was not null, hide the "Blank(No Name/Number)" radio
function hideBlank() {
    var blank = $('input[type=radio][name="properties[Material*]"][value="Blank(No Name/Number)"]');
    var blank2 = $('input[type=radio][name="properties[Material*]"][value="Blank Jersey"]');
    var inputs = $('#bcpo').find('input[type=text]');
    var filePic = $("input[name='properties[Upload Logo]'] , input[name='properties[Team Logo]'], input[name='properties[Back Logo]']");
    inputs.each(function () {

        $(this).bind("input propertychange", function () {
            blank.parent().css("display", "none");
            blank2.parent().css("display", "none");

            var isEmpty = [].reduce.call(inputs, function (a, b) {
                return a && !b.value;
            }, true);
            isEmpty && blank.parent().css("display", "inline-block");
            isEmpty && blank2.parent().css("display", "inline-block");
        });
    });

    $(".bcpo-buttons").eq(1).on("click", "label", function () {
        if ($(this).text().indexOf("Blank") != -1) {
            filePic.parent().css("display", "none");
            filePic.parent().prev().css("display", "none");
            inputs.each(function () {
                $(this).prop("disabled", "disabled");
            });
        } else {
            filePic.parent().css("display", "");
            filePic.parent().prev().css("display", "");
            inputs.each(function () {
                $(this).prop("disabled", "");
            })
        }
    })
}


function ClickMi() {
    //wwh8.5新增
    $(".touchevents").css({
        overflow: 'hidden'
    })
    document.body.style.overflow = 'hidden';
    //wwh8.4新增
    document.getElementById("buttom-x").style.display = 'block';
    var mi_popup_height = $("#mi-popup-kk").height() + 25;
    var buttomleftvalue = ($('body').width() - $("#buttom-x").width()) > 0 ? ($('body').width() - $("#buttom-x").width()) : ($("#buttom-x").width() - $('body').width())
    $(".buttom-x").css({
        top: mi_popup_height + 'px',
        left: buttomleftvalue / 2 + 'px',
    })
    $("#mask-mi").css("height", $(document).height());
    $("#mask-mi").css("width", $(document).width());
    $("#mask-mi").show();
    var $Popup = $('.mi-popup-kk');
    var leftvalue = ($('body').width() - $Popup.width()) > 0 ? ($('body').width() - $Popup.width()) : ($Popup.width() - $('body').width())

    var topvalue = ($(window).height() - $Popup.height() - 350) >= 0 ? '3' : '4';

    $Popup.css({
        left: leftvalue / 2 + 'px',
        top: topvalue / 2 + "rem",
        display: 'block',
        position: 'fixed'
    });
    //wwh新增
    var _title = $(".product_name").html();
    if (_title.indexOf('Baseball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/baseball_219fd43a-4252-4517-9914-0e4c0b99a61e.jpg?v=1659596354");
    }
    if (_title.indexOf('Basketball') != -1) {
        if (_title.indexOf('Shorts') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/shorts.jpg?v=1659596354");
        } else if (_title.indexOf('Suit') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_suit_76acdc09-4ccb-4b27-ac73-7e4a75a2bd7a.jpg?v=1659596354");
        } else {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_da1ff709-2631-4755-9f3f-b3ae91d70c39.jpg?v=1659596354");
        }
    }
    if (_title.indexOf('Football') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/football_fe7e41e8-be36-4412-908f-bdf8a5f71f5e.jpg?v=1659596354");
    }
    if (_title.indexOf('Golf') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/golf.jpg?v=1659596354");
    }
    if (_title.indexOf('Hat') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hats.jpg?v=1659596354");
    }
    if (_title.indexOf('Hockey') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hockey.jpg?v=1659596354");
    }
    if (_title.indexOf('Hoodie') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hoodies.jpg?v=1659596354");
    }
    if (_title.indexOf('Pants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/pant.jpg?v=1659596354");
    }
    if (_title.indexOf('Soccer') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/soccer_b18e2250-daea-4aac-8bc8-dbe7fac31909.jpg?v=1659596354");
    }
    if (_title.indexOf('Jacket') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/JD22101901.jpg?v=1666168588");
    }
    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') < 0) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/t-shirt_96c8c99b-ee96-46b0-a4e2-eb668c723d15.jpg?v=1659596354");
    }

    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0278/0263/2328/files/TZ22082205-01.jpg?v=1665124550");
    }
    if (_title.indexOf('Jogger Sweatpants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/Blank.jpg?v=1667894022");
    }
  if (_title.indexOf('Volleyball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/AZ24072430.jpg?v=1722494930");
    }
}




function showFileName(is) {
    //读取图片数据
    var blank = $('input[type=radio][name="properties[Material*]"][value="Blank(No Name/Number)"]');
    var filePic = is[0].files[0];
    var valFilePic = is.val();
    var reader = new FileReader();
    reader.onload = function (e) {
        var data = e.target.result;
        //加载图片获取图片真实宽度和高度
        var image = new Image();
        image.onload = function () {
            var width = image.width;
            var height = image.height;
            if (width > 400 && height > 400) {
                if (/.(jpg|jpeg|png)$/.test(valFilePic) != false) {
                    is.parent().parent().append("<img class='upload_th_img' style='width:120px !important'></img>");
                    var url = getObjectURL(filePic);
                    is.parents('.bcpo-file').find('.upload_th_img').attr("src", url);
                    blank.parent().css("display", "none");
                } else {
                    is.val("");
                    alert("Please upload pictures in png jpg format.");
                    return false;
                }
            } else {
                is.val("");
                alert("Sorry, the pixel of your image should be larger than 400*400, please upload again.");

                return false;
            }
        };
        image.src = data;
    };
    reader.readAsDataURL(filePic);
}


//自定义获取图片路径函数
function getObjectURL(file) {
    var url = null;
    if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
    } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
    } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
    }
    return url;
}


function getFileName(path) {
    var pos1 = path.lastIndexOf('/');
    var pos2 = path.lastIndexOf('\\');
    var pos = Math.max(pos1, pos2);
    if (pos < 0) {
        return path;
    }
    else {
        return path.substring(pos + 1);
    }
}


function eq_page() {
    // page 頁面
    var page = $('#shopify-section-template--16403274498296__pf-7fa86b28 .pf-c');
    $.each(page, function (index, item) {
        var interval3 = setInterval(() => {
            if ($(this).find('.is-visible').length > 0) {
                $(this).find('.splide__slide').eq(1).siblings().removeClass('is-active is-visible');
                $(this).find('.splide__slide').eq(1).addClass('is-active is-visible')
                clearInterval(interval3);
            }
        }, 2000)

    })
}

function hide_Upload(e,Upload_Logo) {
  var logo_val = $('input[name="properties[Logo Location(Optional)][]"]:checked , input[name="properties[Logo Location(Optional)]"]:checked ').val();
  var this_val = e.prev('input').val();
  if (logo_val != undefined) {
    if (logo_val != 'None') {
      if (this_val != 'None') {
        Upload_Logo.css("display", "block !important");;
        e.parents('.single-option-selector').find('input[value="None"]').removeAttr("checked");
      } else {
        Upload_Logo.css("display", "none !important");
        e.parents('.single-option-selector').find('input').removeAttr("checked");
      }
    } else {
      Upload_Logo.css("display", "none !important");
    }

  } else {
    if (e.parents('.single-option-selector').find('input').attr('name') == 'properties[Logo Location(Optional)][]') {
      Upload_Logo.css("display", "none !important");
    } else {
      if (this_val != "None") {
        Upload_Logo.css("display", "block !important");
      } else {
        Upload_Logo.css("display", "none !important");
      }
    }
  }

}

function add_button(goods_name) {
    document.getElementById("purchase-details__buttons").addEventListener('click', function (event) {
        var Gender = $('input[name="properties[Gender*]"]:checked , input[name="properties[Gender]"]:checked ');
        if ($('#bcpo').length > 0 && (Gender.length > 0 || goods_name.indexOf('hat') > -1)) {
            var Material = $('input[value="Blank(No Name/Number)"]');
            var text = $('#bcpo').find('input[type="text"]').parent();
            var Location = $('input[name="properties[Logo Location(Optional)]"][value="None"]');
            var filenum = $('#bcpo').find('.upload_th_img')
            var ac = $('input[name="properties[A/C Patch on Left Chest (Optional)]"]:checked');
            var acValue = ac.length ? ac.val() : 'None';
          console.log(acValue)
            if ($('#bcpo').find('input[type="file"]').length > 0) {
                var fileInput = $('#bcpo').find('input[type="file"]').get(0).files[0];
            }
            var num = 0;
            text.find('input').each(function () {
                if ($(this).val().length > 0) {
                    num = $(this).val().length;
                    return false;
                }
            });
            if (Material.is(":checked") == false && Material.length > 0) {
                if (num == 0 && fileInput == undefined && filenum.length == 0 && acValue =='None') {
                    $('#bcpo').find('input[type="text"]').attr("disabled", true);
                    $('input[value="Blank(No Name/Number)"]').trigger("click");
                }
            }
            if (fileInput == undefined && filenum.length == 0) {
                Location.trigger("click");
            }

            if (Material.length < 1 && (goods_name.indexOf('pants') > -1 || goods_name.indexOf('hat') > -1)) {
                if (num == 0 && fileInput == undefined) {
                    alert('Please fill in the commodity process information');
                    return false;
                } else {
                    $('#add_to_cart').removeAttr('disabled')
                }
            }

            $('#add_to_cart').trigger("click");
        } else {
            alert('Product customization information failed to load, please refresh the page and add to the shopping cart again!');
            return false;
        }

    });

}